import { IVenue } from 'btdt-types';

export const getVenueUrl = (venue: IVenue): string => {
  return `/venues/${venue.id}-${(venue.nameEn || venue.name).toLowerCase().replace(/ /gi, '-')}`;
};
